/*
 * @Author: Scherger 
 * @Date: 2018-11-28 10:00:32 
 * @Last Modified by: Scherger
 * @Last Modified time: 2019-10-23 20:24:44
 */
import goFun from "@/utils/cc-webapp/navigator.js";
import utilsFun from "@/utils/utils.js";

import {
  CONFIG
} from "@/api/apiConfig.js";
import requestFun from "@/utils/cc-webapp/request.js";

var w_session = '4bb8b9f00cb54a2cbeeee126170c0db3'
var clientType = 'android' //用戶使用的設備類型，

var dev = false

//系统  Android or iOS
const APP_SYSTEM = (() => {
  var system = ''
  try {
    system = JSON.parse(native.getDeviceInfo()).system
  } catch (error) {

  }

  return system
})()



/** 获取静默登录信息
 * 
 * @param  {string} checkUserType 默认不校验，存在内容则校验内容，不成功则返回错误
 * 
 * @param  {string} isJump 是否跳转。存在内容或为true是不跳转， 默认不填或为false 则为跳转（为了语义可填入 'no login'，便于区分）
 * 
 * @Example
 *  当前只有ios有静默登录
 *  安卓用户默认成功返回
 * 
 * @Example
 *    静默登录为开启时有session成功返回
 *    静默登录为开启，本地没有session时 请求匿名session 并成功返回
 * 
 * @Example
 *    静默登录为关闭时返回错误
 *    静默登录为关闭时并且本地有session时，清空本地session
 * 
 * @returns {String}  成功时返回 isAndorid、 haveAnonymousOrSession
 * 
 * @returns {String}  错误时返回 noneAnonymous checkFalse
 * 
 */
function checkSilent(checkUserType, isJump) {

  var gotoPage = {
    path: utilsFun.splitUrl('login'),
    isTransWindows: true
  }

  return new Promise((resolve, reject) => {

    if (APP_SYSTEM == "Android") {
      resolve('isAndorid')
      return
    }

    // console.log('run this check silent')

    return requestFun.doAxios(CONFIG.USER.ANONYMOUS, {}, "GET").then(anonymousResult => {


        let flag = anonymousResult.data //1 开启   0关闭

        this.getSession('no login').then(sessionResult => {

          let session = JSON.parse(sessionResult)

          // console.log(session)

          //存在session
          if (session) {

            if (flag == 0) {
              //关闭状态检查本地session是否为游客，
              //是则清除本地session返回错误，
              //不是则返回成功
              if (session.userType == 'visitor') {
                // console.log('run remove')
                // alert('login checkSilent')
                //native.showToast("匿名已過期請退出重新登錄");
                //native.removeStorage('app_session');
                localStorage.removeItem("app_session")


                if (!isJump) {
                  goFun.openTo(gotoPage)
                }

                reject('noneAnonymous')

              } else {

                if (session.userType != checkUserType) {

                  if (!isJump) {
                    goFun.openTo(gotoPage)
                  }
                  reject('checkFalse')

                } else {
                  resolve('haveAnonymousOrSession')
                }

              }

            } else {
              //开启状态检查先是否存在判断用户类型
              //若存在且不想等则返回错误 ，相等则返回成功
              //若不存在则返回成功

              if (checkUserType) {

                if (session.userType != checkUserType) {

                  if (!isJump) {
                    goFun.openTo(gotoPage)
                  }
                  reject('checkFalse')

                } else {
                  resolve('haveAnonymousOrSession')
                }

              } else {
                resolve('haveAnonymousOrSession')
              }

            }


          } else {
            //没有session的时候,并且为开启状态请求匿名session

            if (flag == 1) {

              requestFun.doAxios(CONFIG.USER.LOGINBYDEVICEID, {}, "GET").then(res => {

                let obj = res.data.session;
                obj["clientType"] = APP_SYSTEM;

                if (res.data.userInfo) {
                  obj['userInfo'] = res.data.userInfo
                }


                // console.log(' is session',obj);

                this.setSession(obj).then(() => {
                  //请求成功后返回成功状态
                  resolve('newAnonymous')
                })

              }).catch(err => {
                //请求错误则统一返回 noneAnonymous
                if (!isJump) {
                  goFun.openTo(gotoPage)
                }

                reject('noneAnonymous')
              });


            } else {

              if (!isJump) {
                goFun.openTo(gotoPage)
              }

              reject('noneAnonymous')
            }

          }


        }).catch(err => {
          //请求错误则统一返回 noneAnonymous
          if (!isJump) {
            goFun.openTo(gotoPage)
          }
          reject('noneAnonymous')
        });


      })
      .catch(err => {
        //请求错误则统一返回 noneAnonymous
        if (!isJump) {
          goFun.openTo(gotoPage)
        }
        reject('noneAnonymous')
      });

  })

}

/** get 不支持router跳转，只能在客户端上使用
 * 
 *  @param  {boolean} loginFlag  是否需要跳转登录页， true / false
 * 
 * @Examples
 * 此方法只负责获取 session , 不校验
 * @Examples
 * 没有session默认打开新窗口进入登录页
 * 
 * @Examples
 * loginFlag 
 * true 为跳转
 * false 为返回空 
 * 
 */
function get(loginFlag) {

  return new Promise((resolve, reject) => {

    if (dev) {
      resolve({
        session: w_session,
      })
      return
    }

    this.getSession().then(session => {


      if (session) {

        let sessionData = JSON.parse(session)

        resolve({
          session: sessionData.session,
          userId: sessionData.userId
        })

      } else { //本地没有session

        //检查是否需要跳转首页
        if (loginFlag) {

          let obj = {
            path: utilsFun.splitUrl('login'),
            isTransWindows: true
          }

          goFun.openTo(obj)

          reject('no session')

        } else {
          resolve({
            session: null,
          })
        }

      }

    })
  })

}

/**
 * 打开登录界面
 * 
 */
function go() {
  let obj = {
    path: utilsFun.splitUrl('login'),
    isTransWindows: true
  }
  goFun.openTo(obj)
}

/**检测session 是否过期
 */
function judgeSession() {

  // console.log('run this');

  // this.check(false, true)


}


/** 检查登录状态 支持router形式 , 并且检查session 是否过期
 * @param  {string} isJudge 是否跳转。存在内容或为true是不跳转， 默认不填或为false 则为跳转（为了语义化可填入 'no login'，便于日后区分）
 * @param  {string} userType 是否判断用户类型  若判断不相等则前往登录页
 * @Example
 * expireAt //三个月失效
 * @Example
 * gotoPage
 * 
 *  var gotoPage = {
      router: this.$router, //默认跳首页没有 router
      path: url,  //跳转的url参数 默认跳首页
    }
 * 
 * 
 */
function check(isJudge, userType) {

  let url = utilsFun.splitUrl('login')
  var GotoData = {
    path: url,
    params: {},
    isTransWindows: true
  };

  return new Promise((resolve, reject) => {

    if (dev) {
      resolve(w_session)
      return
    }

    this.getSession().then(session => {



      if (session) {


        let data = JSON.parse(session)


        if (userType && data.userType) { // 若存在userType字段則校驗   兼容测试阶段用户session没有该字段

          if (userType != data.userType) { //判断用户类型是否和传入的用户类型相等

            if (!isJudge) { //是否跳转
              goFun.openTo(GotoData)
              return
            } else {
              reject('is no session')
            }

          }

        }

        let value = data.value;

        value = JSON.parse(value);

        let etime =  value.expireAt; //data.expireAt

        let toDayTime = Date.now()

        let m1 = new Date(toDayTime + 2592000000).getTime() //30天 （1个月）
        let m2 = new Date(toDayTime + 5184000000).getTime() //60天 （2个月）

        console.log('run this _checkSesion 1', toDayTime, etime, m1, m2);



        if (m1 < etime && etime < m2) {
          console.log('大于1个月并且小于两个月，更新session');

          requestFun.doSessionAxios(CONFIG.USER.REFRESHSESSION, {}, "GET", false, data).then(res => {
            // alert('login check')
          //  native.showToast("授權已過期請退出重新登錄");
            //native.removeStorage('app_session');
            //未调试，直接清除，让用户重新登录
            // this.setSession(res)
            localStorage.removeItem("app_session")
            this.setSession(res)

          }).catch(err => {
            //更新session错误
            // console.log(err);

          })

          resolve(data)

        } else if (toDayTime < etime) {
          console.log('未过期')
          resolve(data)

        } else {
          console.log('check---过期');

          if (isJudge) { //是否跳转
            //清空session
            // alert('login check 2')
            // native.showToast("登錄授權已過期請退出重新登錄");
            // native.removeStorage('app_session');
            localStorage.removeItem("app_session")
            reject('is no session')
          } else {
          //  goFun.openTo(GotoData)
          }

        }

      } else {
        //没有session 

        // if (!isJudge) { //是否跳转
        //   goFun.openTo(GotoData)
        // } else {
        //   reject('is no session')
        // }

      }




    })
  })

}

/** 关闭登录页面
 */
function closeLogin() {
  let obj = {
    backPage: 'login'
  }
  goFun.closeW(obj)


}

/** 将session存储到本地中 (异步)
 * @param  {String} data 缓存的登录数据
 */
function setSession(data) {
  return new Promise((resolve, reject) => {
    var setData = {
      key: 'app_session',
      value: JSON.stringify(data)
    };

    //存储数据做处理
    localStorage.setItem('app_session', JSON.stringify(setData));
    //native.setStorage(JSON.stringify(setData));

    resolve(data)
  })
}


/** 从本地缓存中同步获取session
 * @returns 返回缓存的登录数据，无则返回 false
 */
function getSession() {

  return new Promise((resolve, reject) => {
    var dataValue =  localStorage.getItem('app_session'); //native.getStorage('app_session');

    //console.log("getSession dataValue", dataValue);


    if (dataValue) {
      resolve(dataValue)

    } else {
      resolve(false)
    }
  })

}

/** 退出登錄
 * 
 */
function returnLogin() {
  // native.showToast("正在退出當前帳號！");
  // alert('returnLogin')
  // native.removeStorage('app_session');
  // native.removeStorage('audioPlayrecord');
  // native.showToast("成功退出當前帳號！");

  localStorage.removeItem("app_session")


  //native.hidePlayBar();


  setTimeout(() => {
    let obj = {
      backPage: 'setting'
    }
    goFun.closeW(obj)

  }, 3500);

}

/** 
 * 檢查登錄狀態的方法。
 * goLoginFlag ： 是否跳轉登錄，如果沒有登錄，則直接跳轉登錄頁
 * 有登錄，則resolve，沒有登錄則reject
 */
function checkV2(goLoginFlag) {
  return new Promise((resolve, reject) => {
    this.getSession().then(session => {
      if (session) {
        try {
          let sessionData = JSON.parse(session)
          resolve() //返回成功
        } catch (error) {
          reject() //返回異常
        }

      } else {
        //沒有登錄
        if (goLoginFlag) {
          let obj = {
            path: utilsFun.splitUrl('login'),
            isTransWindows: true
          }
          goFun.openTo(obj)
          reject() //返回異常
        } else {
          reject() //返回異常
        }
      }
    })
  })
}


export default {
  go,
  get,
  check,
  checkV2,
  getSession,
  setSession,
  closeLogin,
  returnLogin,
  judgeSession,
  checkSilent,
}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/login.js